export default {
	SET_LAYOUT: (state, payload ) => {
        state.layout = payload
    },
    SET_AVTAR: (state, uobj ) => {
        state.uobj = uobj
    },
    SET_USER: (state, uobj ) => {
      state.userdata = uobj
    },
    setAlertMessage: (state, message) => {
      state.alertMessage = message
    },
    SET_NOTIFICATION_COUNT: (state, count) => {
      state.notificationCount = count
    },
    SET_NOTIFICATIONS: (state, arr) => {
      state.notifications = arr
    },
    setNavigate: (state, message) => {
      state.navigate = message
    },
    setFCMToken: (state, message) => {
      state.fcmt = message
    },
    SET_RINGING: (state, payload) => {
      state.ringing = payload;
    },
    SET_CALL_STATUS: (state, payload) => {
      state.callStatus = payload;
    },
    SET_VIDEOCALL_PAYLOAD : (state, payload) => {
      state.videocallPayload = payload;
    },
    SET_VIDEO_LAYOUT: (state) => {
      state.minimised = !state.minimised
    },
    SET_SOCKET: (state, payload) => {
      state.socket = payload
    }
}